import React from "react";
import { Link } from "react-router-dom";
import app from "../../base";
import { Card, Col, Row } from "antd";
import "./RentalList.css";

class RentalList extends React.Component {
  constructor(props) {
    super(props);
    this.ref = app.firestore().collection("rentals");
    this.unsubscribe = null;
    this.state = {
      rentals: [],
    };
  }
  
  onCollectionUpdate = (querySnapshot) => {
    const rentals = [];
    querySnapshot.forEach((doc) => {
      const {
        rental_name,
        owner,
        address,
        phone,
        email,
        location,
      } = doc.data();
      rentals.push({
        key: doc.id,
        doc, // DocumentSnapshot
        rental_name,
        owner,
        address,
        phone,
        email,
        location,
      });
    });
    this.setState({
      rentals,
    });
  };
  componentDidMount() {
    this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
  }
  render() {
    return (
      <div className="main">
        <div className="site-card-wrapper">
          {this.state.rentals.map((rental) => (
            <Link to={`/explore/${rental.key}`}>
              <Card
                title={rental.rental_name}
                bordered={false}
                className="cardContent"
              ></Card>
            </Link>
          ))}
        </div>
      </div>
    );
  }
}

export default RentalList;
